import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from './Tooltip';

interface RemoveCardButtonProps {
  onRemove: () => void;
  children: React.ReactNode;
}

export const RemoveCardButton: React.FC<RemoveCardButtonProps> = ({
  onRemove,
  children,
}) => {
  return (
    <div
      style={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
      }}
      onMouseEnter={(e) => {
        const removeButton = e.currentTarget.querySelector(
          '.remove-card-button'
        ) as HTMLElement;
        if (removeButton) {removeButton.style.opacity = '1';}
      }}
      onMouseLeave={(e) => {
        const removeButton = e.currentTarget.querySelector(
          '.remove-card-button'
        ) as HTMLElement;
        if (removeButton) {removeButton.style.opacity = '0';}
      }}
    >
      {children}
      <Tooltip content="Remove card" position="top">
        <button
          className="remove-card-button"
          style={{
            zIndex: 1,
            opacity: '0',
            transition: 'opacity 0.2s ease-in-out',
          }}
          onClick={onRemove}
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </Tooltip>
    </div>
  );
};
